import { useParams } from "react-router-dom";
import PartnerForm from "../components/PartnersForm";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { selectAuthentificated } from "../../../auth/AuthUserSlice";
import { useSelector } from "react-redux";
import { useKeycloak } from "@react-keycloak/web";
import { useDisclosure } from "@mantine/hooks";
import { Input, Paper, Modal } from "@mantine/core";


const AddPartners = () => {
  const {} = useParams();
  const [opened, { open, close }] = useDisclosure(false);
  const {t} = useTranslation("common");
  const [display, setDisplay] = useState(false);
  const isAuthentificated = useSelector(selectAuthentificated); 
  const { keycloak, initialized } = useKeycloak();
  const [openedConfirm, setOpenedConfirm] = useState(false);

  const openConfirmModal = () => { setOpenedConfirm(true);open(); }
  const closeConfirmModal = () => { setDisplay(true);setOpenedConfirm(false);close(); }

  var Timer = setTimeout(()=>{}, 1000);
  function setFormDisplay() {
      closeConfirmModal();
      setDisplay(true);
  };


  useEffect(()=>{
    openConfirmModal();
  },[]);
  
  return (
    <>
        <main>
          <section>
              <div id="card-content" className={display ? '' : 'h-vh'}>
                  <div className="row">
                      {
                        display &&
                        <div className="card card-2 mmb-7 mt-3 ml-auto mr-auto">
                          <div className="card-body">
                              <div className="p-4">
                                  <div className="d-flex flex-column mb-4">
                                    <div>
                                      <div className="change-request-title d-flex ">
                                        { t('structure.structureCreate') }
                                      </div>
                                      <hr/>
                                        <div
                                          className="wf-change-request-content"
                                          style={{
                                            padding: "15px",
                                            paddingLeft: "2.5%",
                                            paddingRight: "2.5%"
                                          }}
                                        >      
                                          <PartnerForm  />
                                        </div>
                                      </div>
                                    </div>
                              </div>
                          </div>
                        </div>
                      }

                      <Modal opened={openedConfirm} onClose={closeConfirmModal} size="30rem" centered >
                          <div style={{ fontSize: "17px" }} > 
                            <div className="text-center" dangerouslySetInnerHTML={{__html: t('settings.redirectMessage', { br: '<br/>'})}}>
                            
                            </div>
                            <div className="d-flex mt-2 justify-center">
                                <button onClick={setFormDisplay} className="btn btn-primary">
                                  { t('app.continue') }
                                </button>
                            </div>
                          </div>
                      </Modal> 
                  </div>
              </div>
          </section>
        </main>
    </>
  );
}
export default AddPartners;